var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5459_22393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1243 0C8.19944 0 0.125 8.07444 0.125 17.9993C0.125 27.9242 8.19944 35.9986 18.1243 35.9986C28.0492 35.9986 36.1236 27.9242 36.1236 17.9993C36.1236 8.07444 28.0492 0 18.1243 0ZM27.2485 23.6166C27.0187 23.995 26.6087 24.2068 26.1933 24.2068C25.9704 24.2068 25.7461 24.1449 25.5411 24.0211L17.4736 19.0545C17.1076 18.8317 16.8834 18.4272 16.8834 17.9993V6.20614C16.8834 5.52375 17.4419 4.96518 18.1243 4.96518C18.8067 4.96518 19.3653 5.52375 19.3653 6.20614V17.3032L26.844 21.9093C27.4287 22.2697 27.6089 23.0333 27.2485 23.6166Z",
    fill: "#4D4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5459_22393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.125)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHour);
export default __webpack_public_path__ + "static/media/hour.81760d7bd9cee15a2f2306253167a755.svg";
export { ForwardRef as ReactComponent };